import { render, staticRenderFns } from "./AdminStreams.vue?vue&type=template&id=1e4a190a&"
import script from "./AdminStreams.vue?vue&type=script&lang=ts&"
export * from "./AdminStreams.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports